/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "M3R4J",
  title: "Hi, I'm Afsarul Islam Meraj.",
  subTitle: emoji(
    "A dedicated and highly organized software engineer with a passion for learning and solving complex problems. Skilled in TypeScript, NestJS, Node.js, PostgreSQL, and MongoDB."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/aim3r4j",
  linkedin: "https://www.linkedin.com/in/m3r4j/",
  gmail: "afsarulislammeraj4@gmail.com",
  facebook: "https://www.facebook.com/m3r4j",
  instagram: "https://www.instagram.com/m3r4j_",
  twitter: "https://www.twitter.com/m3r4j",
  devto: "https://dev.to/m3r4j",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Skills",
  subTitle: "Backend Engineer With Full-Stack Capabilities",
  skills: [],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "NodeJS",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fab fa-ts"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "PHP",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "Laravel",
      fontAwesomeClassname: "fab fa-laravel"
    },
    {
      skillName: "ReactJS",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "VueJS",
      fontAwesomeClassname: "fab fa-vuejs"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Brac University, Dhaka.",
      logo: require("./assets/images/bracu.png"),
      subHeader: "Computer Science & Engineering",
      duration: "2018 - 2022"
    },
    {
      schoolName: "Notre Dame College, Dhaka.",
      logo: require("./assets/images/ndc.png"),
      subHeader: "Science",
      duration: "2015 - 2017"
    },
    {
      schoolName: "Cumilla Zilla School, Cumilla.",
      logo: require("./assets/images/czs.png"),
      subHeader: "Science",
      duration: "2009 - 2015"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer II (Augmented)",
      company: "Banglalink Digital Communications Ltd.",
      companylogo: require("./assets/images/bl.png"),
      date: "May 2025 – Present",
      desc: "Banglalink Digital Communications Ltd. is the best mobile operator that provides the strongest & widest network at each & every corner in Bangladesh.",
      isBgBlack: true
    },
    {
      role: "Software Engineer II",
      company: "Astha.IT",
      companylogo: require("./assets/images/ait.png"),
      date: "May 2025 – Present",
      desc: "A global tech company offering top-rated coding talent for scalable solution development.",
      isBgBlack: true
    },
    {
      role: "Software Engineer",
      company: "Red Technologies Limited",
      companylogo: require("./assets/images/rtl.png"),
      date: "November 2023 – April 2025",
      desc: "A prominent fintech company, pioneering the financial industry with cutting-edge technological solutions.",
      isBgBlack: false
    },
    {
      role: "Software Engineer (Backend)",
      company: "Rainier Technologies",
      companylogo: require("./assets/images/rainier.jpg"),
      date: "January 2023 - October 2023",
      desc: "A US-based Health Tech Startup.",
      isBgBlack: false
    },
    {
      role: "Technology Intern (Product Delivery, Merchant Products, Product & Technology Division.)",
      company: "bKash",
      companylogo: require("./assets/images/bkash.png"),
      date: "October 2022 - December 2022",
      desc: "bKash provides fast, secure and convenient money transfer and payment services via mobile phone to the people of Bangladesh",
      isBgBlack: false
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/sManager.webp"),
      projectName: "Sheba Manager",
      projectDesc: "Helped build their sManager App's backend. sManager is an ERP solution for SMEs which acts as a tool to grow their business. It’s an user-friendly app, carefully designed to automate all processes.",
      footerLink: [
        {
          name: "Check out the app",
          url: "https://play.google.com/store/apps/details?id=xyz.sheba.managerapp&hl=en"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/sa.png"),
      projectName: "Science Academy",
      projectDesc: "Built their system/backend. Their mission is to empower VCE students with the knowledge and confidence they need to excel in their studies and achieve outstanding results in their final exams.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.scienceacademy.com.au/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        { name: "Certification", url: "" },
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://dev.to/m3r4j/sernam-the-easy-way-to-generate-unique-usernames-with-javascript-and-nodejs-593l",
      title: "Sernam: The Easy Way to Generate Unique Usernames with Javascript and NodeJS",
      description:
        "Are you tired of coming up with usernames for your users or yourself? Do you want a quick and easy way to generate unique usernames without having to spend a lot of time thinking about it? Look no further than Sernam, the username generator for Javascript and NodeJS."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+880-1758701262",
  email_address: "afsarulislammeraj4@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "m3r4j", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
